// extracted by mini-css-extract-plugin
module.exports = {"pipelineDetailsRow":"review_pipelineDetailsRow__gS5Qk","rowSubTitle":"review_rowSubTitle__37aMS","rowValues":"review_rowValues__1bR9P","actionBtns":"review_actionBtns__3QFNR"};